interface StepperProps {
  currentStep: number;
  totalSteps: number;
  labels: string[];
}

export default function Stepper({ currentStep, totalSteps, labels }: StepperProps) {
  return (
    <div className="flex items-center justify-between w-full max-w-4xl mx-auto mb-8">
      {Array.from({ length: totalSteps }, (_, i) => {
        const stepNum = i + 1;
        const isActive = stepNum === currentStep;
        const isCompleted = stepNum < currentStep;
        const isLast = i === totalSteps - 1;

        return (
          <div key={stepNum} className="flex items-center flex-1">
            <div className="flex flex-col items-center">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-200"
                style={{
                  background: isCompleted ? '#0D7A3C' : isActive ? 'var(--accent)' : '#E5E5E8',
                  color: isCompleted || isActive ? '#fff' : '#6B6B70',
                  border: isActive ? '2px solid var(--accent)' : '2px solid transparent',
                }}
              >
                {isCompleted ? (
                  <i className="ri-check-line text-base"></i>
                ) : (
                  stepNum
                )}
              </div>
              <span
                className="mt-2 text-xs font-medium whitespace-nowrap"
                style={{
                  color: isActive ? 'var(--accent)' : isCompleted ? '#0D7A3C' : '#6B6B70',
                }}
              >
                {labels[i]}
              </span>
            </div>
            {!isLast && (
              <div
                className="flex-1 h-0.5 mx-3 transition-all duration-300"
                style={{
                  background: isCompleted ? '#0D7A3C' : '#E5E5E8',
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}